import {
    initClient,
    setAssetDomain,
    thenightly,
} from '@news-mono/component-library'
import {
    authCheckAccessToken,
    loadUserLocation,
    retrieveLocationQueryString,
} from '@news-mono/web-common'

setAssetDomain()
// We need this to get the dependencies loaded in the correct order
require('../app/app')

const { render, routeCacheRef } = initClient({
    version: { buildNumber: '', sha: '' },
    beforeInitialised: async ({ store, log, config }) => {
        if (window.location.search.indexOf('location') !== -1) {
            const region = retrieveLocationQueryString(window.location)
            store.dispatch(loadUserLocation(region))
        }
        await store.dispatch(
            authCheckAccessToken({
                onEvent: () => {},
                config,
                log,
                invocation: 'auto',
            }),
        )
    },
    requireApplication: () => require('../app/app').App,
    theme: thenightly,
})

if (module.hot) {
    module.hot.accept('../app/app', () => {
        if (routeCacheRef) {
            routeCacheRef.clear()
        }

        setTimeout(render)
    })
}
